import { jsx as _jsx } from "react/jsx-runtime";
import PageLoader from "../loader/page-loader/page-loader";
const ScreenLoading = () => _jsx(PageLoader, {});
export default ScreenLoading;
